<script>
import iconHasGot from '@/images/cms/coupons/stamp_received@2x.png'
import iconNoStock from '@/images/cms/coupons/stamp_none@2x.png'

export default {
  functional: true,
  render(h, { props, listeners }) {
    const progressWidth = Math.floor(((100 - props.percentage) / 100) * 113)
    const restPercentage =
      Number(100 * 100 - props.percentage * 100).toFixed(2) / 100
    let statusText =
      props.stockStatus === 0
        ? `剩余可抢 ${restPercentage}%`
        : props.stockStatus === 1
        ? '已经领过啦，快去使用吧'
        : '已抢光，下次早点来哦~'
    // 简易版状态文本【针对可领取】
    if (props.showType === 'simple') {
      switch (props.stockStatus) {
        case 0:
          statusText = '快来领取吧～'
          break
        case 1:
          statusText = '已经领过啦～'
          break
        case 2:
          statusText = '已经抢光啦～'
          break
      }
    }

    const stamp =
      props.stockStatus === 1
        ? iconHasGot
        : props.stockStatus === 2
        ? iconNoStock
        : ''

    const showReceiveBtn = props.canGet
    return (
      <div
        style={props.couponStyle}
        class={`coupon-${props.showType}${!props.canGet ? ' deactive' : ''}${
          props.stockStatus === 2 ? ' soldout' : ''
        }`}
      >
        <div class="left">
          <p class="coupon-value">
            <span class="symbol">￥</span>
            <span class="value">{props.couponValue}</span>
          </p>
          <p class="threshold">{props.thresholdMsg}</p>
        </div>
        <div class="right">
          <div class="info">
            <p class="name">{props.couponName}</p>
            <div class="status progress">
              {showReceiveBtn && (
                <div class={['progress-bar']}>
                  <div class="background"></div>
                  <div
                    class="foreground"
                    style={{
                      width: `${progressWidth}px`
                    }}
                  ></div>
                </div>
              )}
              <p class="text">{statusText}</p>
            </div>
          </div>
          {showReceiveBtn ? (
            <div class="action" onClick={listeners['receive-coupon']}>
              <p>立即领取</p>
            </div>
          ) : (
            stamp && <img class="stamp" src={stamp} />
          )}
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@mixin cross_line($height, $line_color) {
  &::before {
    position: absolute;
    top: 0;

    width: 100%;
    height: $height;
    margin: 4px 0px;

    border-right: 1px dashed $line_color;

    content: '';
  }
}
@mixin coupon_left_style($left_width, $cross_line_height, $line_color) {
  position: relative;

  width: $left_width;

  flex: none;

  @include flex(column, center, stretch nowrap);

  @include cross_line($cross_line_height, $line_color);

  .coupon-value {
    @include flex(row, center, flex-end, nowrap);

    .symbol,
    .value {
      position: relative;
      bottom: 2px;

      flex: none;

      font-size: 16px;
      color: #ff5c00;
    }

    .symbol {
      line-height: 20px;
    }

    .value {
      margin-left: -1px;

      font-size: 32px;
      font-weight: 600;
    }
  }

  .threshold {
    margin-top: 4px;

    font-size: 12px;
    text-align: center;
    color: #ff5c00;
    @include text-overflow-ellipsis-single;
  }
}
@mixin receive-button {
  width: 1.4rem;
  height: 0.48rem;

  background-image: linear-gradient(to right, #ff7d00, #ff5c00);

  border-radius: 0.24rem;

  @include flex-row-center;

  p {
    font-size: 0.24rem;

    color: #fff;
  }
}
.coupon-normal {
  height: 84px;
  overflow: hidden;

  border-radius: 6px;
  @include coupon-bg-width-circle(#fff8f5, 86px, 84px, 5px, 1px);

  @include flex(row, flex-start, stretch, nowrap);

  &:first-child {
    margin-top: 0;
  }

  .left {
    @include coupon_left_style(86px, 76px, #ffd5be);
  }
  .right {
    position: relative;

    padding: 16px 14px 11px 20px;

    overflow: hidden;

    flex: auto;

    @include flex(row, flex-start, stretch, nowrap);

    .info {
      overflow: hidden;

      flex: auto;

      @include flex(column, center, stretch, nowrap);

      .name {
        z-index: 9;

        font-size: 15px;
        line-height: 18px;
        font-weight: $fw-semi-bold;
        color: $c-text-normal;

        @include text-overflow-ellipsis-single;
      }

      .status {
        margin-top: 15px;

        .progress-bar {
          position: relative;

          margin-bottom: 5px;

          &.hidden {
            visibility: hidden;
          }

          .background {
            width: 100px;
            height: 8px;

            background-color: #ffdecd;
            border-radius: 4px;
          }

          .foreground {
            position: absolute;
            top: 0;
            left: 0;

            width: 60px;
            height: 8px;

            background-image: linear-gradient(90deg, #ff7d00 2%, #ff5c00 100%);
            border-radius: 4px;
          }
        }

        .text {
          font-size: 12px;
          color: $c-text-lighter;
        }
      }
    }

    .action {
      position: absolute;
      right: 14px;
      bottom: 11px;
      @include receive-button;
    }

    .stamp {
      position: absolute;
      right: -2px;
      bottom: -15px;

      width: 1.04rem;
    }
  }

  &.deactive {
    .right {
      padding-bottom: 16px;

      .info {
        @include flex(column, space-between, stretch, nowrap);
      }
    }
  }

  &.soldout {
    background-image: radial-gradient(
      circle at 86px 5px,
      transparent 0%,
      transparent 5px,
      #f3f3f3 5px,
      #f3f3f3 85px
    );
    background-position: 0 -6px;

    background-size: 100% 86px;

    .left {
      &::before {
        position: absolute;
        top: 0;

        width: 100%;
        height: 76px;
        margin: 4px 0px;

        border-right: 1px dashed #e2e2e2;

        content: '';
      }

      .coupon-value {
        .symbol,
        .value {
          color: #999;
        }
      }
      .threshold {
        color: #999;
      }
    }

    .right {
      .info {
        .name {
          color: $c-text-light;
        }
      }
    }
  }
}
.coupon-simple {
  height: 1.48rem;
  overflow: hidden;

  border-radius: 6px;
  @include coupon-bg-width-circle(#fff8f5, 1.94rem, 1.48rem, 0.1rem, 0.02rem);

  @include flex(row, flex-start, stretch, nowrap);

  /* stylelint-disable */
  .left {
    @include coupon_left_style(1.94rem, 1.32rem, #ffd5be);
  }

  .right {
    position: relative;

    padding: 0.36rem 0.48rem 0.36rem 0.4rem;

    overflow: hidden;

    flex: auto;
    @include flex(row, space-between, center, nowrap);

    .info {
      overflow: hidden;

      flex: auto;

      @include flex(column, center, stretch, nowrap);

      .name {
        z-index: 9;

        font-size: 0.26rem;
        line-height: 0.3rem;
        font-weight: $fw-semi-bold;
        color: $c-text-normal;

        @include text-overflow-ellipsis-single;
      }

      .status {
        margin-top: 0.24rem;
        .text {
          font-size: 0.24rem;
          color: $c-text-lighter;
        }
      }
    }

    .action {
      flex: none;
      margin-left: 0.2rem;
      @include receive-button;
    }

    .stamp {
      position: absolute;
      right: -0.04rem;
      bottom: -0.3rem;

      width: 1.04rem;
    }
    /* stylelint-enable */
  }

  &.soldout {
    @include coupon-bg-width-circle(#f3f3f3, 1.94rem, 1.48rem, 0.1rem, 0.02rem);
    .left {
      @include cross_line(1.32rem, #e2e2e2);

      .coupon-value {
        .symbol,
        .value {
          color: #999;
        }
      }
      .threshold {
        color: #999;
      }
    }

    .right {
      .info {
        .name {
          color: $c-text-light;
        }
      }
    }
  }
}
</style>
